import React from 'react';
import { NoiseLullabies } from './pages/NoiseLullabies';
export function App() {
  return <NoiseLullabies data-id="element-0" />;
}